import React from 'react';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataCertification } from 'components/common/element-data/types';
import ElementDataRowLabel from 'components/common/element-data/ElementDataRowLabel';
import ElementDataRowValue from 'components/common/element-data/ElementDataRowValue';
import CertificationData from 'components/common/CertificationData';
import { dispatchCustomEvent } from 'tools/events';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';
import { useSelector } from 'react-redux';

export default function Certification(props: IElementDataCertification) {
    const {
        certifiedInd = false,
        certificationLevelColor,
        certificationLevelName = '',
        lastCertifiedByName = '',
        lastCertifiedTime = '',
        lastCertifiedByEmail = '',
        tileInfoData = {},
        settings,
    } = props;
    const fieldKey: ElementMetadataFieldName = 'certification';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);
    const customEvents = useSelector((state: any) => state.concierge.customEvents);

    if (!fieldMetadataDisplay || !certifiedInd) return null;

    return (
        <ElementDataRow
            order={fieldMetadataOrder}
            sx={{
                '.element-data-row-label': {
                    color: certificationLevelColor,
                },
            }}
        >
            <ElementDataRowLabel icon={{ type: 'mi', value: 'certified' }} />
            <ElementDataRowValue>
                <CertificationData
                    certificationData={{
                        color: certificationLevelColor,
                        name: certificationLevelName,
                        lastUpdatedBy: lastCertifiedByName,
                        lastUpdatedTime: lastCertifiedTime,
                    }}
                    onUserNameClick={
                        settings?.isAppPanel && customEvents?.certified_username_click
                            ? () => {
                                  dispatchCustomEvent('mi-concierge-panel', {
                                      action: 'certified-username-click',
                                      payload: {
                                          item: tileInfoData,
                                      },
                                  });
                              }
                            : lastCertifiedByEmail
                            ? () => {
                                  window.location.href = `mailto:${lastCertifiedByEmail}`;
                              }
                            : undefined
                    }
                    markUserName={true}
                />
            </ElementDataRowValue>
        </ElementDataRow>
    );
}
